(function() {
  const section = document.querySelector('.shop-mushroom');
  if (!section) return;

  const productsContainer = section.querySelector('.shop-mushroom__products');
  const leftArrow = section.querySelector('.shop-mushroom__arrow--left');
  const rightArrow = section.querySelector('.shop-mushroom__arrow--right');
  const navLinks = section.querySelectorAll('.shop-mushroom__nav-link');
  const progressIndicator = section.querySelector('.shop-mushroom__progress-indicator');
  
  let currentIndex = 1; // Start with second item (index 1)
  let currentCollection = null;
  let visibleProducts = [];

  // Function to get visible products for current collection
  function getVisibleProducts() {
    const activeLink = section.querySelector('.shop-mushroom__nav-link.active');
    const activeCollection = activeLink ? activeLink.dataset.collection : null;
    
    const allCards = productsContainer.querySelectorAll('.shop-mushroom__product-card');
    return Array.from(allCards).filter(card => card.dataset.collection === activeCollection);
  }

  // Function to setup carousel for current collection
  function setupCarousel() {
    visibleProducts = getVisibleProducts();
    
    if (visibleProducts.length === 0) return;

    // Hide all non-matching products
    const allCards = productsContainer.querySelectorAll('.shop-mushroom__product-card');
    allCards.forEach(card => {
      if (!visibleProducts.includes(card)) {
        card.style.display = 'none';
      } else {
        card.style.display = 'flex';
      }
    });

    // Reset current index to second item (or first if less than 2 items)
    currentIndex = Math.min(1, visibleProducts.length - 1);
  }

  // Function to update product positioning and active state
  function updateCarousel(immediate = false) {
    if (visibleProducts.length === 0) return;

    // Remove active class from all products
    visibleProducts.forEach(card => card.classList.remove('active'));

    // Add active class to current product
    if (visibleProducts[currentIndex]) {
      visibleProducts[currentIndex].classList.add('active');
    }

    // Calculate positioning
    const containerWidth = productsContainer.parentElement.offsetWidth;
    const isMobile = window.innerWidth <= 853;
    const productWidth = isMobile ? 600 : 812;
    const gap = 16; // Gap between products
    const totalProductWidth = productWidth + gap;
    const centerOffset = (containerWidth / 2) - (productWidth / 2);
    const transform = centerOffset - (currentIndex * totalProductWidth);

    // Apply transform
    if (immediate) {
      productsContainer.style.transition = 'none';
      productsContainer.style.transform = `translateX(${transform}px)`;
      // Force reflow
      productsContainer.offsetHeight;
      productsContainer.style.transition = '';
    } else {
      productsContainer.style.transform = `translateX(${transform}px)`;
    }

    // Update arrow states
    updateArrows();
  }

  // Function to update arrow states
  function updateArrows() {
    if (visibleProducts.length <= 1) {
      leftArrow.classList.add('disabled');
      rightArrow.classList.add('disabled');
      return;
    }

    if (currentIndex <= 0) {
      leftArrow.classList.add('disabled');
    } else {
      leftArrow.classList.remove('disabled');
    }

    if (currentIndex >= visibleProducts.length - 1) {
      rightArrow.classList.add('disabled');
    } else {
      rightArrow.classList.remove('disabled');
    }
  }

  // Function to update progress bar
  function updateProgressBar() {
    if (!progressIndicator || visibleProducts.length === 0) return;

    const totalItems = visibleProducts.length;
    
    // If only one item, show full width
    if (totalItems === 1) {
      progressIndicator.style.width = '100%';
      progressIndicator.style.left = '0%';
      return;
    }
    
    const indicatorWidth = (1 / totalItems) * 100; // One item width
    const progress = (currentIndex / (totalItems - 1)) * (100 - indicatorWidth);

    progressIndicator.style.width = indicatorWidth + '%';
    progressIndicator.style.left = Math.max(0, Math.min(100 - indicatorWidth, progress)) + '%';
    
    // Debug: Make sure it's visible
    progressIndicator.style.display = 'block';
    progressIndicator.style.backgroundColor = '#000000';
    progressIndicator.style.height = '4px';
  }

  // Function to go to next product
  function nextProduct() {
    if (currentIndex >= visibleProducts.length - 1) return;
    currentIndex++;
    updateCarousel();
    updateProgressBar();
  }

  // Function to go to previous product
  function prevProduct() {
    if (currentIndex <= 0) return;
    currentIndex--;
    updateCarousel();
    updateProgressBar();
  }

  // Arrow click handlers
  leftArrow.addEventListener('click', prevProduct);
  rightArrow.addEventListener('click', nextProduct);

  // Handle collection navigation
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Don't do anything if clicking the same link
      if (link.classList.contains('active')) return;
      
      // Add switching animation
      productsContainer.classList.add('switching');
      
      // Update active link
      navLinks.forEach(l => l.classList.remove('active'));
      link.classList.add('active');

      // Update current collection
      currentCollection = link.dataset.collection;
      
      // Wait for fade out, then rebuild and fade in
      setTimeout(() => {
        // Setup carousel for new collection
        setupCarousel();
        
        // Remove switching class and update carousel
        productsContainer.classList.remove('switching');
        
        // Update carousel display
        setTimeout(() => {
          updateCarousel();
          updateProgressBar();
        }, 50);
      }, 200); // Match the CSS transition duration
    });
  });

  // Handle keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      prevProduct();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      nextProduct();
    }
  });

  // Handle touch/swipe gestures
  let startX = 0;
  let isDragging = false;

  productsContainer.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  });

  productsContainer.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    
    const endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;
    
    if (Math.abs(diffX) > 50) { // Minimum swipe distance
      if (diffX > 0) {
        nextProduct();
      } else {
        prevProduct();
      }
    }
    
    isDragging = false;
  });

  // Handle mouse drag
  let startDragX = 0;
  let startDragging = false;

  productsContainer.addEventListener('mousedown', (e) => {
    startDragX = e.clientX;
    startDragging = true;
  });

  document.addEventListener('mouseup', (e) => {
    if (!startDragging) return;
    
    const endX = e.clientX;
    const diffX = startDragX - endX;
    
    if (Math.abs(diffX) > 50) { // Minimum drag distance
      if (diffX > 0) {
        nextProduct();
      } else {
        prevProduct();
      }
    }
    
    startDragging = false;
  });

  productsContainer.addEventListener('mouseleave', () => {
    startDragging = false;
  });

  // Handle window resize
  window.addEventListener('resize', () => {
    updateCarousel(true); // Immediate update without transition
    updateProgressBar();
  });

  // Initialize carousel
  function initCarousel() {
    // Set up first collection
    const firstLink = navLinks[0];
    if (firstLink) {
      navLinks.forEach(l => l.classList.remove('active'));
      firstLink.classList.add('active');
      currentCollection = firstLink.dataset.collection;
    }

    // Setup carousel
    setupCarousel();
    
    // Initial carousel display
    setTimeout(() => {
      updateCarousel();
      updateProgressBar();
    }, 100);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousel);
  } else {
    initCarousel();
  }
})();

